const filters = (function() {
  const menuLabels = document.getElementsByClassName('filter-nav-label');
  const menuLabelsArray = [].slice.call(menuLabels);
  const filterSettings = document.getElementById('filter-settings');
  const filterHint = document.getElementById('filter-hint');
  const filterLabel = document.getElementById('filter-label');
  const filterTutorial = document.getElementById('filter-tutorial');
  const filterArrow = document.getElementById('filter-arrow');
  const filter = document.getElementById('filter-filter');
  const isFilterSelected = filter.getAttribute('data-selected');
  const hash = window.location.hash.substring(1);
  const resetButton = document.getElementById('fybf-reset');
  const step1 = document.getElementById('fybf-step1');
  const step2 = document.getElementById('fybf-step2');
  const step3 = document.getElementById('fybf-step3');
  const sizeFilter = document.getElementById('filter-size');
  const wetFilter = document.getElementById('filter-wet');
  const thinFilter = document.getElementById('filter-thinnes');

var filtered_products = '';
  var step1_filtered_products = '';
var filtered_counter = '';
var filtered_pagination = ''; 
var filtered_pagination2 = '';
  const _config = {
    opened: 9,
    slider: 0,
    resizeHandler: 0,
    factor: 1.57,
  };

  function setCookie(cname, cvalue) {
    document.cookie = `${cname}=${cvalue}path=/`;
  }

  function getCookie(cname) {
    const name = `${cname}=`;
    const decodedCookie = decodeURIComponent(document.cookie);
    const ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i += 1) {
      let cookie = ca[i];
      while (cookie.charAt(0) === ' ') {
        cookie = cookie.substring(1);
      }
      if (cookie.indexOf(name) === 0) {
        return cookie.substring(name.length, cookie.length);
      }
    }
    return '';
  }

  function enableTooltip() {
    const tooltiptext = document.getElementById('tooltiptext');
    const toolTip = document.getElementsByClassName('fybf-tooltip');
    if (typeof toolTip !== 'undefined' && toolTip.length > 0) {
      const tooltipArray = [].slice.call(toolTip);
      tooltipArray[0].addEventListener('mouseover', () => {
        tooltiptext.style.visibility = 'visible';
        const topPos = tooltipArray[0].getBoundingClientRect().top + window.scrollY;
        const leftPos = tooltipArray[0].getBoundingClientRect().left + window.scrollX;
        const height = tooltiptext.offsetHeight;
        tooltiptext.style.left = `${leftPos - 240 + 32}px`;
        tooltiptext.style.top = `${topPos - height - 8}px`;
      });
      tooltipArray[0].addEventListener('mouseleave', () => {
        tooltiptext.style.visibility = 'hidden';
      });
    }
  }

  function showHint() {
    filterHint.classList.remove('hidden');
  }

  function hideHint() {
    setCookie('_filterHint', 'hidden');
    filterHint.classList.add('hidden');
  }

  function showTooltip() {
    const toolTip = document.getElementsByClassName('fybf-tooltip');
    const tooltipArray = [].slice.call(toolTip);
    for (let i = 0; i < tooltipArray.length; i += 1) {
      tooltipArray[i].classList.add('visible');
    }
  }

  function hideTooltip() {
    const toolTip = document.getElementsByClassName('fybf-tooltip');
    const tooltipArray = [].slice.call(toolTip);
    for (let i = 0; i < tooltipArray.length; i += 1) {
      tooltipArray[i].classList.remove('visible');
    }
  }

  function showArrow() {
    filterArrow.classList.add('open');
  }

  function hideArrow() {
    filterArrow.classList.remove('open');
  }

  function showLabel() {
    filterLabel.classList.remove('hidden');
  }

  function hideLabel() {
    filterLabel.classList.add('hidden');
  }

  function showReset() {
    if (resetButton.classList.contains('visible') === false) {
      resetButton.classList.add('visible');
    }
  }

  function showStep1() {
    step1.classList.add('visible');
    step1.classList.remove('disabled');
    step1.setAttribute('tabindex', 0);
  }

  function showStep2() {
    step2.classList.remove('disabled');
    step2.classList.add('visible');
    step2.setAttribute('tabindex', 0);
  }

  function showStep3() {   
    step3.classList.add('visible');
    step3.classList.remove('disabled');
    step3.setAttribute('tabindex', 0);
  }

  function hideReset() {
    resetButton.classList.remove('visible');
  }

  function hideDisabledStep1(){
    step1.classList.remove('visible');
    step1.setAttribute('tabindex', -1);
  }

  function hideDisabledStep2(){
    step2.classList.remove('visible');
    step2.setAttribute('tabindex', -1);
  }

  function hideDisabledStep3(){
    step3.classList.remove('visible');
    step3.setAttribute('tabindex', -1);
  }

  function hideStep1() {
    step1.classList.add('visible');
    step1.classList.add('disabled');
  }

   function enableSizeFilter() {
    sizeFilter.classList.remove('disabled');
    sizeFilter.tabIndex = "0";
    sizeFilter.focus();
  }

 function enableWetFilter() {
    wetFilter.classList.remove('disabled');
    wetFilter.tabIndex = "0";
  }  

   function enableThinFilter() {
    thinFilter.classList.remove('disabled');
    thinFilter.tabIndex = "0";
  }

   function disableSizeFilter() {
    sizeFilter.classList.add('disabled');
     sizeFilter.tabIndex = "-1";
  }
  
   function disableWetFilter() {
    wetFilter.classList.add('disabled');
     wetFilter.tabIndex = "-1";
  }  

   function disableThinFilter() {
    thinFilter.classList.add('disabled');
     thinFilter.tabIndex = "-1";
  }

  function hideStep2() {
    step2.classList.add('visible');
    step2.classList.add('disabled');
  }

  function hideStep3() {
    step3.classList.add('visible');
    step3.classList.add('disabled');
  }

  function setTab() {
    const collection = document.getElementsByClassName('collection-page__row');
    const collection2 = document.getElementsByClassName('collection-page__sort');
    const collection3 = document.getElementsByClassName('collection-page__pagination');
    const carousel2 = document.getElementById('shopify-section-fybf-carousel');
    
    closeTutorial();
    showLabel();
    showArrow();
    if (isFilterSelected === 'true') {
      showStep1();
      hideDisabledStep3();
      hideDisabledStep2();
      showReset();
      disableWetFilter();
      disableThinFilter();
    } else {
      collection2[0].style.display = "none";
      collection2[0].style.height = 0;
      collection2[0].style.position = "absolute";
      collection[0].style.display = "none";
      collection[0].style.height = 0;
      collection[0].style.position = "absolute";
      
      hideReset();
      disableWetFilter();
      disableThinFilter();
      hideDisabledStep3();
      hideDisabledStep2();
      hideDisabledStep1();
    }
      if (isFilterSelected !== 'true') {
        showHint();
      } else {
        //hideHint();
      }
      setSlider(0, true);
      openSettings(0);
  }
var collectionURL = '';
  function init() {
    jQuery('.pagination, #filter-close-wrapper, .products_filter_wrapper').on('click', 'a', function(event) {
      event.preventDefault();
      const $item = $(this);
      const pagination2 = $(this).closest('.pagination');
       collectionURL = $item.attr('href');
      if ($item[0].classList.contains('fybf-link')) {
        const filterBlock = $item.closest('.custom_filter');
        const otherActive = filterBlock.find('.checked');
        if (otherActive.length > 0) {
          const currentHandle = otherActive.attr('data-handle');
          collectionURL = $item.attr('href').replace(`${currentHandle}+`, '');
        } else {
          collectionURL = $item.attr('href');
        }
      }
      window.history.pushState({
        param: Shopify.queryParams,
      }, document.title, collectionURL);
      $('.collection-page__row').addClass('loading');
      $.ajax({
        url: window.top.location,
        type: 'GET',
        success(data) {
          const $response = $(data);
          const products = $response.find('.collection-page__grid').html();
          const size = $response.find('#filter-fsize-options').html();
          const fsize = $response.find('#filter-size').html();
          const fwet = $response.find('#filter-wet').html();
          const fthinnes = $response.find('#filter-thinnes').html();
          const wet = $response.find('#filter-fwet-options').html();
          const thinnes = $response.find('#filter-fthinnes-options').html();
          const counter = $response.find('.collection-page__sort__count').html();
          const pagination = $response.find('.pagination').html();
          const collection = document.getElementsByClassName('collection-page__row');
          $('.filter-wrapper').addClass('active');
          $('.collection-page__grid').html(products);
        
          $('#filter-fsize-options').html(size);
          $('#filter-size').html(fsize);
          $('#filter-wet').html(fwet);
          $('#filter-thinnes').html(fthinnes);
          $('#filter-fwet-options').html(wet);
          $('#filter-fthinnes-options').html(thinnes);
            $('.collection-page__sort__count').html(counter);
            $('.pagination').html(pagination);
          setTimeout(() => {
            $('.collection-page__row').removeClass('loading');
          }, 300);
          enableTooltip();
          showTooltip();
          const isSelected = $response.find('#filter-filter').data('selected');

          if (isSelected === true) {
            showReset();
          } else {
             const collection = document.getElementsByClassName('collection-page__row');
             const collection2 = document.getElementsByClassName('collection-page__sort');
             const collection3 = document.getElementsByClassName('collection-page__pagination');
            collection2[0].style.display = "none";
            collection[0].style.display = "none";

            hideReset();
            hideDisabledStep1();
            hideDisabledStep2();           
            hideDisabledStep3();
            $('#filter-size').trigger('click');
            $('.filter-wrapper').removeClass('active');
            enableSizeFilter();
            disableThinFilter();
            disableWetFilter();
          }
          const scrollTo = $('.collection-page__sort').offset().top;
          if (pagination2.length > 0) {
            window.scrollTo({
              top: scrollTo,
              behavior: 'smooth',
            });
          }
        },
      });
    });

    jQuery('#filter-filter').on('click', 'a', function(event) {
      event.preventDefault();
      const $item = $(this);
      const pagination2 = $(this).closest('.pagination');
      if ($item[0].classList.contains('fybf-link')) {
        const filterBlock = $item.closest('.custom_filter');
        const otherActive = filterBlock.find('.checked');
        if (otherActive.length > 0) {
          const currentHandle = otherActive.attr('data-handle');
          collectionURL = $item.attr('href').replace(`${currentHandle}+`, '');
        } else {
          collectionURL = $item.attr('href');
        }
      }
      window.history.pushState({
        param: Shopify.queryParams,
      }, document.title, collectionURL);
     $('.custom_filter.active a').not(this).each(function(){
         $(this).parent().removeClass('checked');
     });
      $('.custom_filter.active .checked').removeClass('checked')
      $(this).parent().toggleClass('checked');
      $('.collection-page__row').addClass('loading');
      $.ajax({
        url: window.top.location,
        type: 'GET',
        success(data) {
          const $response = $(data);
          const products = $response.find('.collection-page__grid').html();
          if(window.location.href.includes('fsize_') && !window.location.href.includes('fwet_') && !window.location.href.includes('fthinnes_')){
            step1_filtered_products = products;
          }
          filtered_products = products;
          const size = $response.find('#filter-fsize-options').html();
          const fsize = $response.find('#filter-size').html();
          const fwet = $response.find('#filter-wet').html();
          const fthinnes = $response.find('#filter-thinnes').html();
          const wet = $response.find('#filter-fwet-options').html();
          const thinnes = $response.find('#filter-fthinnes-options').html();
          const counter = $response.find('.collection-page__sort__count').html();
          filtered_counter = counter;
          const pagination = $response.find('.pagination').html();
          filtered_pagination = pagination;
          
          $('#filter-fsize-options').html(size);
          $('#filter-size').html(fsize);
          $('#filter-wet').html(fwet);
          $('#filter-thinnes').html(fthinnes);
          $('#filter-fwet-options').html(wet);
          $('#filter-fthinnes-options').html(thinnes);
          
          setTimeout(() => {
            $('.collection-page__row').removeClass('loading');
          }, 300);
          enableTooltip();
          showTooltip();
          const isSelected = $response.find('#filter-filter').data('selected');

            if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && window.location.href.includes('fthinnes_') && $('#filter-thinnes').attr('class').indexOf('active') > 0) {
              showStep3();
              hideDisabledStep1();
              hideDisabledStep2();
              showReset();
            }else if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && $('#filter-wet').attr('class').indexOf('active') > 0) {
              showStep2();
              hideDisabledStep1();
              hideDisabledStep3();
              showReset();
            }else if (window.location.href.includes('fsize_') && $('#filter-size').attr('class').indexOf('active') > 0) {
              showStep1();
              hideDisabledStep2();
              hideDisabledStep3();
             showReset();
            }else if (window.location.href.includes('fsize_') && $('#filter-wet').attr('class').indexOf('active') > 0){
              hideStep2();
              disableThinFilter();
              hideDisabledStep1();
              hideDisabledStep3();
              showReset();
            }else if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && $('#filter-thinnes').attr('class').indexOf('active') > 0) {
              hideStep3();
              hideDisabledStep1();
              hideDisabledStep2();
            showReset();
          } else {
            hideReset();
            hideDisabledStep1();
            hideDisabledStep2();           
            hideDisabledStep3();
            disableThinFilter();
            disableWetFilter();
          }

        },
      });
    });
    
    $( document ).ready(function() {      
      $("#filter-hide").click(function() {
         $(".how-to-choose__wrapper").slideDown(1000);
         $('.how_to_container').hide();
        $('html, body').animate({
          scrollTop: $("#shopify-section-fybf-how-to-choose").offset().top
        }, 1000);
      });
      
       $("#filter-hide1").click(function() {
        $('html, body').animate({
          scrollTop: $("#shopify-section-collection-fybf").offset().top
        }, 1000);
      });

       $("#how_choose_fit--button").click(function() {
        $('html, body').animate({
          scrollTop: $("#shopify-section-collection-fybf").offset().top
        }, 1000);
      });

      $("#choose_your_fit").click(function() {
        $(".how-to-choose__wrapper").slideDown(1000);
        $('.how_to_container').hide();
        $('html, body').animate({
          scrollTop: $("#shopify-section-fybf-how-to-choose").offset().top
        }, 1000);
      });
      
      $(".details_expand").on('click', function () {
        $(this).parent().next().slideDown(1000);
        $(this).parent().hide();
        $(this).attr('aria-expanded', 'true');
      });

      $(document).on('click', "#filter-3 .fybf-link", function(){
        console.log("clicked");
        setTimeout(function () {
          $('#fybf-step1').focus();
        }, 2000);
      });
      $(document).on('click', "#filter-4 .fybf-link", function(){
        console.log("clicked");
        setTimeout(function () {
          $('#fybf-step3').focus();
        }, 2000);
      });
      $(document).on('click', "#filter-5 .fybf-link", function(){
        console.log("clicked");
        setTimeout(function () {
          $('#fybf-step2').focus();
        }, 2000);
      });
      
            $(document).on('click', ".product-item.product-item--alt.container ", function(){
        const element = $(this).find('a.fybf_product_container');
                 const id = element.attr('data-id');
            const name = element.attr('data-name');
            const category = element.attr('data-brand');
          const index = element.attr('data-index');
            const itemListId = element.attr('data-item_list_id');
            const brand = element.attr('data-vendor');
            const variant = element.attr('data-variant');

            window.dataLayer.push({
             "event": "select_item",
              "ecommerce": {
                  "item_list_id": itemListId,
                  "item_list_name": category,
                items: [
                {
          "item_id": id,
          "item_name": name,
          "item_category": 'Condoms',
          "item_brand": brand,
          "item_list_id": itemListId,
          "item_list_name": category,
                  "item_variantId": variant
                }
                ]}
            });
       
      });
      
      $('#fybf-step1').click(function(){
        
        $('#filter-wet').trigger('click');
        disableSizeFilter();
        disableThinFilter();
        enableWetFilter();
        if(window.location.href.includes('fwet_')){
          showStep2();
        }else {
            hideStep2();
        }
        hideDisabledStep1();
        hideDisabledStep3();
        $('#filter-wet').focus();
      });

      $('#fybf-step2').click(function(){
        
        $('#filter-thinnes').trigger('click');
        
        hideDisabledStep1();
        hideDisabledStep2();
        disableSizeFilter();
        enableThinFilter();
        disableWetFilter();
        if(window.location.href.includes('fthinnes')){
        showStep3();
        }else {
            hideStep3();
        }
        $('#filter-thinnes').focus();
      });

      $('#filters_reset').click(function(){
        $('.no_results_found').hide();
        $('#fybf-reset').trigger('click');
        $('#filter-size').trigger('click');
        disableThinFilter();
        disableWetFilter();
        enableSizeFilter();
      });

      $('#fybf-step3').click(function(){
        disableSizeFilter();
        disableWetFilter();
        hideDisabledStep3();
        hideReset();
        $('.fybf-step.btn.btn--small.s.visible').removeClass('visible');
        const collection = document.getElementsByClassName('collection-page__row');
        const collection2 = document.getElementsByClassName('collection-page__sort');
        const collection3 = document.getElementsByClassName('collection-page__pagination');
        collection2[0].style.display = "block";
        collection2[0].style.height = 'auto';
        collection2[0].style.position = "relative";
        collection[0].style.display = "block";
        collection[0].style.height = "auto";
        collection[0].style.position = "relative";
        collection[0].classList.add('active');
        collection2[0].classList.add('active');
       $('.filter-wrapper').addClass('active');
      if(filtered_products.trim().includes('<div class="col"><p>Sorry, there are no products in this collection</p></div>') || filtered_products.trim().includes('<div class="col"><p>Désolé, il')) {
        $('.collection-page__grid').html(step1_filtered_products);
        if($('.collection-page__grid .col.l-4.m-6').length > 3){
          var items = document.querySelectorAll(".collection-page__grid .col.l-4.m-6"), index, i;
          var min = 0;
          var max = items.length - 1;
          var count = items.length - 3;
          
          while(count > 0) {
            index = Math.floor(Math.random() * (max - min + 1)) + min;
            if(items[index].style.display != "none") {
              items[index].style.display = "none";
              --count;
            }
          }
        }
        $('.collection-page__sort__count').html(filtered_counter);
        $('.no_results_found').show();
      }else {
        $('.collection-page__grid').html(filtered_products);    
        $('.collection-page__sort__count').html(filtered_counter);
        $('.pagination').html(filtered_pagination);
      }
    });

    });

	for (let i = 0; i < menuLabelsArray.length; i += 1) {
      (function(x) {
        menuLabelsArray[x].addEventListener('click', () => {
          sessionStorage.setItem('filter', x);
          setSlider(x, true);
          _config.slider = x;
          if (_config.opened === x) {
            closeSettings(x);
          } else {
            openSettings(x);
          }
          //hideHint();
        }, true);
        menuLabelsArray[x].addEventListener('keydown', (e) => {
          if (e.keyCode === 13) {
            sessionStorage.setItem('filter', x);
            setSlider(x, true);
            _config.slider = x;
            if (_config.opened === x) {
              closeSettings(x);
            } else {
              openSettings(x);
            }
            //hideHint();
          }
        }, true);
      })(i);

    }
    window.addEventListener('resize', () => {
      if (window.innerWidth < 1024) {
        if (_config.resizeHandler !== true) {
          setSlider(_config.slider);
          _config.resizeHandler = true;
        }
      } else if (_config.resizeHandler !== false) {
        setSlider(_config.slider);
        _config.resizeHandler = false;
      }
    });
  }

  function openFilters(i) {
    const customFilter = document.getElementsByClassName('custom_filter');
    const customFilterArray = [].slice.call(customFilter);
    const filterSize = document.getElementById('filter-fsize-options');
    const filterGirth = document.getElementById('filter-fthinnes-options');
    const filterWet = document.getElementById('filter-fwet-options');
    const flabel = document.getElementsByClassName('flabel');
    const flabelArray = [].slice.call(flabel);
    for (let x = 0; x < customFilterArray.length; x += 1) {
      customFilterArray[x].className = customFilterArray[x].className.replace(' active', '');
      flabelArray[x].className = flabelArray[x].className.replace(' active', '');
    }
    if (i === 0) {
      filterSize.classList.add('active');
      flabelArray[0].classList.add('active');
      showTooltip();
    } else if (i === 2) {
      filterGirth.classList.add('active');
      flabelArray[2].classList.add('active');
      hideTooltip();
    } else if (i === 1) {
      hideTooltip();
      filterWet.classList.add('active');
      flabelArray[1].classList.add('active');
    }
  }

  function setSlider(i, click) {
    let slide = i;
    if (typeof slide === 'undefined') {
      slide = 0;
    }
    const slideUnderline = document.getElementById('underline');
    const current = filterLabel.getElementsByClassName('active');
    let el = parseInt(slide, 10);
    let offset;
    if (typeof el === 'undefined' || el === null || Number.isNaN(el)) {
      el = 0;
    }
    if (window.innerWidth > 1023) {
      if (el === 0) {
        offset = 0;
      } else if (el === 1) {
        offset = 33.33;
      } else if (el === 2) {
        offset = 66.66;
      }
    } else if (window.innerWidth < 1024) {
      if (el === 0) {
        offset = 12.5;
      } else if (el === 1) {
        offset = 45.83;
      } else if (el === 2) {
        offset = 79.16;
      }
    }

    for (let x = 0; x < current.length; x += 1) {
      current[x].className = current[x].className.replace(' active', '');
    }
    if (click === true) {
      filters.openFilters(el);
    }
    menuLabelsArray[el].classList.add('active');
    menuLabelsArray[el].tabIndex = "0";

    if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && window.location.href.includes('fthinnes_') && $('#filter-thinnes').attr('class').indexOf('active') > 0) {
              showStep3();
              hideDisabledStep1();
              hideDisabledStep2();
            }else if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && $('#filter-wet').attr('class').indexOf('active') > 0) {
               showStep2();
              hideDisabledStep1();
              hideDisabledStep3();
            }else if (window.location.href.includes('fsize_') && $('#filter-size').attr('class').indexOf('active') > 0) {
              $('.filter-wrapper').addClass('active');
              showStep1();
              hideDisabledStep2();
              hideDisabledStep3();
            }else if (window.location.href.includes('fsize_') && $('#filter-wet').attr('class').indexOf('active') > 0){
              hideStep2();
              disableThinFilter();
              hideDisabledStep1();
              hideDisabledStep3();
            }else if (window.location.href.includes('fsize_') && window.location.href.includes('fwet_') && $('#filter-thinnes').attr('class').indexOf('active') > 0) {
              hideStep3();
              hideDisabledStep1();
              hideDisabledStep2();
            }
  }

  function openSettings(i) {
    filterSettings.classList.add('open');
    for (let x = 0; x < menuLabelsArray.length; x += 1) {
      menuLabelsArray[x].classList.remove('opened');
    }
    menuLabelsArray[i].classList.add('opened');
    _config.opened = i;
  }

  function closeSettings() {
    filterSettings.classList.remove('open');
    hideTooltip();
    for (let x = 0; x < menuLabelsArray.length; x += 1) {
      menuLabelsArray[x].classList.remove('opened');
    }
    _config.opened = 9;
  }

  function closeEverything() {
    closeTutorial();
    hideArrow();
  }

  function closeTutorial() {
    filterTutorial.classList.remove('open');
    hideArrow();
    setCookie('_filterTutorial', 'hidden');
  }

  function openTutorial() {
    filterTutorial.classList.add('open');
  }
  return {
    enableTooltip,
    getCookie,
    showHint,
    showArrow,
    setTab,
    init,
    setSlider,
    openFilters,
    openSettings,
    closeEverything,
    closeTutorial,
    openTutorial,
  };
})();

function FCarousel() {
  const _config = {
    selector: '.fybf-carousel',
    frame: '.fybf-frame',
    indicatorList: '.fybf-carousel-indicators',
    detailList: '.fybf-details',
    startIndex: 0,
    easing: 'ease-out',
    duration: 400,
    items: [],
  };

  const _status = {
    startX: 0,
    endX: 0,
    position: 0,
    dragging: false,
    pointerDown: false,
    dragOffset: 0,
    clickedItem: 0,
    previousItem: _config.startIndex,
    currentItem: _config.startIndex,
    floor: _config.startIndex,
    ceil: _config.startIndex + 1,
    needRAF: true,
    raf: null,
  };

  function debounce(func, wait, immediate) {
    let timeout;
    return function() {
      const self = this;
      const args = arguments;

      function later() {
        timeout = null;
        if (!immediate) {
          func.apply(self, args);
        }
      }
      const callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) {
        func.apply(self, args);
      }
    };
  }

  function enableTransition() {
    _config.frame.style.webkitTransition = `all ${_config.duration}ms ${_config.easing}`;
    _config.frame.style.transition = `all ${_config.duration}ms ${_config.easing}`;
  }

  function setTick(i) {
    const newd = _config.items[i].getAttribute('data-new');
    const current = _status.currentItem;
    const oldsrc = _config.items[current].dataset.oldDesign;
    const newsrc = _config.items[current].dataset.newDesign;
    const radio = document.getElementById('switch-form');
    if (newd === '1') {
      document.getElementById('radio-b').checked = true;
    } else {
      document.getElementById('radio-a').checked = true;
    }
    if ((oldsrc === '') ^ (newsrc === '')) {
      radio.classList.add('disabled');
      document.getElementById('radio-b').disabled = true;
      document.getElementById('radio-a').disabled = true;
      return;
    }
    if (radio.classList.contains('disabled')) {
      radio.classList.remove('disabled');
      document.getElementById('radio-b').disabled = false;
      document.getElementById('radio-a').disabled = false;
    }

  }

  function setClasses() {
    const current = _status.currentItem;
    const previous = _status.previousItem;
    _config.items[current].classList.add('active');
    _config.indicators[current].classList.add('active');
    _config.detail[current].classList.add('active');
    if (current !== previous) {
      _config.items[previous].classList.remove('active');
      _config.indicators[previous].classList.remove('active');
      _config.detail[previous].classList.remove('active');
    }
    setTick(current);
  }

  function slideCurrent() {
    const offset = _status.currentItem * _status.selectorWidth;
    enableTransition();
    const calculated = (offset * (-1));
    _config.frame.style.transform = `translate3d(${calculated}px, 0,0)`;
    _status.position = offset * (-1);
    setClasses();
  }

  function slideTo(i) {
    let slideToItem = i;
    if (slideToItem < 0) {
      slideToItem = 0;
    }
    if (slideToItem > _config.items.length - 1) {
      slideToItem = _config.items.length - 1;
    }
    _status.previousItem = _status.currentItem;
    _status.currentItem = slideToItem;
    slideCurrent();
  }

  function setItemSizes(boolean) {
    let reset = boolean;
    if (typeof reset === 'undefined') {
      reset = false;
    }
    if (reset === false) {
      const position = ((_status.position + _status.dragOffset) / _status.selectorWidth) * (-1);
      const zero = _config.items.map((x) => {
        return x;
      });
      if (_status.ceil <= _config.items.length - 1 && _status.ceil >= 0) {
        zero.splice(_status.ceil, 1);
        const transform = 0.5 + (Math.round((position - _status.floor) * 50) / 100);
        _config.items[_status.ceil].getElementsByClassName('responsive-image__image')[0].style.transform = `scale(${transform})`;
      }
      if (_status.floor >= 0 && _status.floor <= _config.items.length - 1) {
        zero.splice(_status.floor, 1);
        const transform = 1 - (Math.round((position - _status.floor) * 50) / 100);
        _config.items[_status.floor].getElementsByClassName('responsive-image__image')[0].style.transform = `scale(${transform})`;
      }
      for (let i = 0; i < zero.length; i += 1) {
        const transform = 0.5;
        zero[i].getElementsByClassName('responsive-image__image')[0].style.transform = `scale(${transform})`;
      }
    } else if (reset === true) {
      const zero = _config.items.map((x) => {
        return x;
      });
      const index = _status.currentItem;
      if (index > -1) {
        zero.splice(index, 1);
      }
      for (let i = 0; i < zero.length; i += 1) {
        zero[i].getElementsByClassName('responsive-image__image')[0].style.transform = 'scale(0.5)';
      }
      _config.items[_status.currentItem].getElementsByClassName('responsive-image__image')[0].style.transform = 'scale(1)';
    }
  }

  function isDragging() {
    return Math.abs(_status.dragOffset) > 5;
  }

  function updateCarousel() {
    if (isDragging()) {
      const movement = _status.endX - _status.startX;
      const movementDistance = Math.abs(movement);
      const howManySliderToSlide = Math.ceil(movementDistance / _status.selectorWidth);
      if (movement <= 0) {
        slideTo(_status.currentItem + howManySliderToSlide);
      }
      if (movement > 0) {
        slideTo(_status.currentItem - howManySliderToSlide);
      }
    } else {
      slideTo(_status.currentItem);
    }
    setItemSizes(true);
  }

  function mouseDownHandler(event) {
    event.stopPropagation();
    event.preventDefault();
    _config.selector.style.cursor = '-webkit-grabbing';
    _status.startX = event.pageX;
    _status.pointerDown = true;
  }

  function mouseUpHandler(event) {
    event.stopPropagation();
    event.preventDefault();
    cancelAnimationFrame(_status.raf);
    if (_status.dragging === true) {
      _status.dragging = false;
      updateCarousel();
    } else {
      slideTo(_status.clickedItem);
      setItemSizes(true);
      if (event.target.nodeName === 'A') {
        if (_status.clickedItem === _status.previousItem) {
          window.location = event.target.href;
        }
      }
    }
    _status.pointerDown = false;
    _config.selector.style.cursor = '-webkit-grab';
    _status.needRAF = true;
  }

  function getVisible() {
    const position = ((_status.position + _status.dragOffset) / _status.selectorWidth) * (-1);
    _status.ceil = Math.ceil(position);
    _status.floor = Math.floor(position);
  }

  function update() {
    const position = _status.position + _status.dragOffset;
    _config.frame.style.webkitTransition = `all 0ms ${_config.easing}`;
    _config.frame.style.transition = `all 0ms ${_config.easing}`;
    _config.frame.style.transform = `translate3d(${position}px, 0, 0)`;
    getVisible();
    setItemSizes();
    _status.needRAF = true;
  }

  function mouseMoveHandler(event) {
    event.preventDefault();
    if (_status.pointerDown === true) {
      _status.endX = event.pageX;
      if (isDragging()) {
        _status.dragging = true;
      }
      _status.dragOffset = _status.endX - _status.startX;
      if (_status.needRAF === true) {
        _status.needRAF = false;
        _status.raf = requestAnimationFrame(update);
      }
    }
  }

  function mouseLeaveHandler(event) {
    event.stopPropagation();
    if (_status.dragging === true) {
      cancelAnimationFrame(_status.raf);
      _config.selector.style.cursor = '-webkit-grab';
      _status.pointerDown = false;
      _status.dragging = false;
      _status.position += _status.dragOffset;
      updateCarousel();
      _status.needRAF = true;

    }
  }

  function mouseClickHandler(event) {
    _status.clickedItem = parseInt(event.currentTarget.getAttribute('data-item'), 10) - 1;
  }

  function mouseClick(event) {
    event.preventDefault();
  }

  function touchStartHandler(event) {
    event.preventDefault();
    const dataElement = event.target.parentElement.parentElement.parentElement;
    const data = dataElement.getAttribute('data-item');
    _status.clickedItem = parseInt(data, 10) - 1;
    _status.startX = event.touches[0].pageX;
    _status.pointerDown = true;
  }

  function touchEndHandler(event) {
    cancelAnimationFrame(_status.raf);
    _status.needRAF = true;
    event.stopPropagation();
    if (_status.dragging === true) {
      updateCarousel();
      _status.dragging = false;
    } else {
      slideTo(_status.clickedItem);
      setItemSizes(true);
      if (event.target.nodeName === 'A') {
        if (_status.clickedItem === _status.previousItem) {
          window.location = event.target.href;
        }
      }
      _status.previousItem = _status.clickedItem;
      _status.pointerDown = false;
    }
  }


  function touchMoveHandler(event) {
    if (_status.pointerDown === true) {
      _status.endX = event.touches[0].pageX;
      _status.dragOffset = _status.endX - _status.startX;
      if (isDragging()) {
        _status.dragging = true;
      }

      if (_status.needRAF === true) {
        _status.needRAF = false;
        _status.raf = requestAnimationFrame(update);
      }
    }
    return false;
  }

  function setMiddle() {
    _config.items = [].slice.call(_config.frame.children);
    if (_config.items.length > 1) {
      const middle = Math.round((_config.items.length - 1) / 2);
      _config.startIndex = middle;
      _status.previousItem = _config.startIndex;
      _status.currentItem = _config.startIndex;
      _status.floor = _config.startIndex;
      _status.ceil = _config.startIndex + 1;
    }
    return 0;
  }

  function indicatorsClickHandler(event) {
    _status.clickedItem = parseInt(event.currentTarget.getAttribute('data-item'), 10) - 1;
    slideTo(_status.clickedItem);
    setItemSizes(true);
  }

  function buildFrame() {
    _config.selector = typeof _config.selector === 'string' ? document.querySelector(_config.selector) : _config.selector;
    _status.selectorWidth = _config.selector.offsetWidth;
    _config.frame = typeof _config.frame === 'string' ? document.querySelector(_config.frame) : _config.frame;
    _config.items = [].slice.call(_config.frame.children);
    _config.frame.style.width = `${_config.items.length * _status.selectorWidth}px`;
    const percent = 100 / _config.items.length;
    for (let i = 0; i < _config.items.length; i += 1) {
      _config.items[i].style.width = `${percent}%`;
    }
  }

  function buildRest() {
    _config.indicatorList = typeof _config.indicatorList === 'string' ? document.querySelector(_config.indicatorList) : _config.indicatorList;
    _config.detailList = typeof _config.detailList === 'string' ? document.querySelector(_config.detailList) : _config.detailList;
    _config.indicators = [].slice.call(_config.indicatorList.children);
    _config.detail = [].slice.call(_config.detailList.children);
  }
  const windowResizeHandler = debounce(() => {
    buildFrame();
    slideCurrent();
  }, 250);

  function setDesign(design) {
    const current = _status.currentItem;
    const image = _config.items[current].getElementsByClassName('responsive-image__image')[0];
    const newsrc = _config.items[current].dataset.newDesign;
    const oldsrc = _config.items[current].dataset.oldDesign;
    if (design === 'old') {
      _config.items[current].dataset.new = '0';
      image.src = oldsrc;
    } else {
      _config.items[current].dataset.new = '1';
      image.src = newsrc;

    }
  }

  function attachEvents() {
    _config.selector.addEventListener('mousedown', mouseDownHandler);
    _config.selector.addEventListener('mouseup', mouseUpHandler);
    _config.selector.addEventListener('mousemove', mouseMoveHandler);
    _config.selector.addEventListener('mouseleave', mouseLeaveHandler);
    _config.selector.addEventListener('touchstart', touchStartHandler);
    _config.selector.addEventListener('touchend', touchEndHandler);
    _config.selector.addEventListener('touchmove', touchMoveHandler);
    window.addEventListener('resize', windowResizeHandler);
    for (let i = 0; i < _config.items.length; i += 1) {
      _config.items[i].addEventListener('mousedown', mouseClickHandler, true);
      _config.items[i].addEventListener('click', mouseClick, false);
      _config.indicators[i].addEventListener('click', indicatorsClickHandler, true);
    }
    const radios = document['fybf-switch-form']['first-switch'];
    for (let x = 0; x < radios.length; x += 1) {
      radios[x].addEventListener('change', function() {
        setDesign(this.value);
      });
    }
  }

  function init() {
    buildFrame();
    setMiddle();
    buildRest();
    slideCurrent();
    attachEvents();
    setItemSizes();
  }

  //init();

  return {
    buildFrame,
    slideCurrent,
  };
}

const fyb = new FCarousel();

function polyfills() {
  Number.isNaN = Number.isNaN || function(value) {
    return value !== null && (value != value || Number(value) != value);
  };

  if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
      if (typeof start === 'undefined') {
        start = 0;
      }
      return this.indexOf(search, start) !== -1;
    };
  }
}

window.onload = function() {
  polyfills();
  const filterArrow = document.getElementById('filter-arrow');
  const closeButton = document.getElementById('filter-tut-close');
  const item = sessionStorage.getItem('filter');
  const filter = document.getElementById('filter-filter');
  const isFilterSelected = filter.getAttribute('data-selected');
  const aboutIcons = document.getElementsByClassName('fybf-i-2');
  const aboutIconsArray = [].slice.call(aboutIcons);
  for (let i = 0; i < aboutIconsArray.length; i += 1) {
    aboutIconsArray[i].addEventListener('click', () => {
      filters.openTutorial();
      filters.showArrow();
      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      });
    });
  }
  filters.closeTutorial();
  filters.setTab();
  filterArrow.addEventListener('click', filters.closeEverything);
  closeButton.addEventListener('click', filters.closeTutorial);
  filters.enableTooltip();
  filters.init();

};
